(function (window, document) {
  'use strict';

  var EVENT_MENU = 'allos_menu_click';
  var EVENT_FOOTER = 'allos_footer_click';

  function safeLumTrack(eventId, data) {
    if (typeof window.lum_track !== 'function') {
      return;
    }
    try {
      window.lum_track('event', eventId, data);
    } catch (e) {
      /* fail silently — see design: no retry/queue */
    }
  }

  function onClick(event) {
    var target = event.target;
    var anchor = target && target.closest
      ? target.closest('[data-allos-nav-item]')
      : null;
    if (!anchor) {
      return;
    }

    var surface = anchor.getAttribute('data-allos-nav-surface');
    var eventId = surface === 'footer' ? EVENT_FOOTER : EVENT_MENU;

    var payload = { item: anchor.getAttribute('data-allos-nav-item') || '' };
    /* Omit parent_item entirely for main items — the navigation.parent field-group is optional */
    var parentItem = anchor.getAttribute('data-allos-nav-parent');
    if (parentItem) {
      payload.parent_item = parentItem;
    }

    safeLumTrack(eventId, payload);
  }

  /* Capture phase: still fires when anchor handlers call stopPropagation (e.g. popup $onClick) */
  document.addEventListener('click', onClick, true);
})(window, document);
